let _ = require('lodash');
let moment = require('moment');


export let colId =      {
                            colId: 'Id',
                            headerName: 'Id',
                            field: 'Id',
                            width: 100,
                            sortable: true
                        };
export let colStatus =  {   colId: 'status',
                            headerName: 'Status',
                            field: 'Status',
                            width: 100,
                            sortable: true
                        };
export let colName =  {     colId: 'name',
                            headerName: 'Name',
                            field: 'name',
                            width: 100,
                            sortable: true
                        };

export let colRequestor =  {colId: 'requestor',
                            headerName: 'Requestor',
                            field: 'requestor.friendlyName',
                            width: 100,
                            sortable: true
                        };

export let colAssignedTo =  {
                                colId: 'assignedto',
                                headerName: 'Submitted To',
                                field: 'assignedTo.friendlyName',
                                width: 100,
                                sortable: true
                            };


export let colPriority =  {
                                colId: 'priority',
                                headerName: 'Priority',
                                field: 'priority',
                                width: 100,
                                sortable: true
                            };

export let colPhase =  {
                                colId: 'phase',
                                headerName: 'Phase',
                                field: 'phase',
                                width: 100,
                                sortable: true
                            };

export let colDocumentType =  {
                                colId: 'documentType',
                                headerName: 'Document Type',
                                field: 'documentType',
                                width: 100,
                                sortable: true
                            };


export let colCreatedDate =  {
                                colId: 'createdDate',
                                headerName: 'Created Date',
                                field: 'CreatedDate',
                                width: 75,
                                sortable: true,
                                cellRenderer: dateFormatter
                            };


export let colSubmissionDate =  {
                                colId: 'submissionDate',
                                headerName: 'Submission Date',
                                field: 'SubmissionDate',
                                width: 75,
                                sortable: true,
                                cellRenderer: dateFormatter
                            };


export let colDaysInProcess =  {
                                    colId: 'daysInProcess',
                                    headerName: 'Days In Process',
                                    field: 'SubmissionDate',
                                    width: 50,
                                    sortable: true,
                                    cellRenderer: numberOfDaysCalculator
                                };



export let colEffectiveDate =  {
                                colId: 'effectiveDate',
                                headerName: 'Desired Effective Date',
                                field: 'effectiveDate',
                                width: 100,
                                sortable: true,
                                cellRenderer: dateFormatter
                            };


export let colInternalCoordinators =  {
                                colId: 'inernalcoordinators',
                                headerName: 'Internal Coordinators',
                                field: 'internalCoordinators',
                                width: 100,
                                sortable: true,
                                cellRenderer: userArrayFormatter
                            };

export let colOwner =  {    colId: 'owner',
                            headerName: 'Owner',
                            field: 'object.owner',
                            width: 100,
                            sortable: true
                        };


export let allColumns = [

    colId,
    colStatus,
    colName,
    colRequestor,
    colAssignedTo,
    colPriority,
    colPhase,
    colDocumentType,
    colCreatedDate,
    colSubmissionDate,
    colDaysInProcess,
    colEffectiveDate,
    colInternalCoordinators,
    colOwner
];


export let columnSelectList = [
    {
        value: colId,
        viewValue: colId.headerName
    },
    {
        value: colStatus,
        viewValue: colStatus.headerName
    },
    {
        value: colName,
        viewValue: colName.headerName
    },
    {
        value: colRequestor,
        viewValue: colRequestor.headerName
    },
    {
        value: colAssignedTo,
        viewValue: colAssignedTo.headerName
    },
    {
        value: colPriority,
        viewValue: colPriority.headerName
    },
    {
        value: colPhase,
        viewValue: colPhase.headerName
    },
    {
        value: colDocumentType,
        viewValue: colDocumentType.headerName
    },
    {
        value: colCreatedDate,
        viewValue: colCreatedDate.headerName
    },
    {
        value: colSubmissionDate,
        viewValue: colSubmissionDate.headerName
    },
    {
        value: colDaysInProcess,
        viewValue: colDaysInProcess.headerName
    },
    {
        value: colEffectiveDate,
        viewValue: colEffectiveDate.headerName
    },
    {
        value: colInternalCoordinators,
        viewValue: colInternalCoordinators.headerName
    },
    {
        value: colOwner,
        viewValue: colOwner.headerName
    }
];


function userArrayFormatter(param) {

    // console.log('userArrayFormatter: ', param.data);

    let userArray = [];

    if (param.data.internalCoordinators) {
            param.data.internalCoordinators.forEach(user => {
                userArray.push(user.friendlyName);
            });

        // console.log('userArray: ', userArray);

        // return ['foobar'];
        return userArray.toString();
    } else {
        return null;
    }



    // let scoreAsNumber = Number(param.data.riskScore);
    // let scoreAsFloat = scoreAsNumber.toFixed(1);

    // if ((scoreAsFloat != undefined) &&
    //     (scoreAsFloat != 'NaN')) {
    //   return scoreAsFloat;
    // } else {
    //   return '';
    // }
  }



    function numberOfDaysCalculator(params) {

        if (params.value) {
            let dateObject = moment.unix(params.value);
            let now = moment();
    
            if (dateObject.isValid()) {
                // return dateObject.diff(now, 'days');
                return now.diff(dateObject, 'days');
            } else {
                dateObject = moment(params.value);
    
                if (dateObject.isValid()) {
                    return now.diff(dateObject, 'days');
                }
            }
        } else {
            // console.log('params.value has no value');
        }
    }


  function  dateFormatter(params) {

    if (params.value) {
        let dateObject = moment.unix(params.value);
        let friendlyDate = dateObject.format('ll');

        if (dateObject.isValid()) {
            return friendlyDate;
        } else {
            dateObject = moment(params.value);

            if (dateObject.isValid()) {
                friendlyDate = dateObject.format('ll');
                return friendlyDate;
            }
        }
    }
}
